import { Grid } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import FormularioPesquisa from '../../features/questionnaire/controller/FormularioPesquisa';

const Evento: React.FC = () => {
  const { useCase } = useParams<{ event: string; useCase: string }>();

  const renderUseCase = () => {
    switch (useCase) {
      case '1':
        console.log('useCase: 1');
        return null;

      case '2':
        return <FormularioPesquisa />;

      case '3':
        console.log('useCase: 3');
        return null;

      default:
        return null;
    }
  };

  return <Grid>{renderUseCase()}</Grid>;
};

export default Evento;
